
import React from 'react';
import { MapPin, Star } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { EscortProfile } from '@/types';

interface ProfileCardContentProps {
  profile: EscortProfile;
  canSeeRates: boolean;
}

const ProfileCardContent = ({ profile, canSeeRates }: ProfileCardContentProps) => {
  return (
    <div className="space-y-3">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-semibold text-lg truncate">{profile.displayName}</h3>
          <div className="flex items-center text-muted-foreground text-sm">
            <MapPin size={14} className="mr-1 flex-shrink-0" />
            <span className="truncate">{profile.location.city}, {profile.location.country}</span>
          </div>
        </div>
        <div className="flex items-center bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full">
          <Star size={14} className="text-amber-500 mr-0.5" />
          <span className="text-sm font-medium">4.8</span>
        </div>
      </div>
      
      <p className="text-sm text-muted-foreground line-clamp-2">
        {profile.bio.short}
      </p>
      
      {/* Additional info */}
      <div className="flex flex-wrap gap-1 mt-auto pt-2">
        {profile.attributes.languages.slice(0, 3).map((language, index) => (
          <Badge key={index} variant="outline" className="text-xs">
            {typeof language === 'string' ? language : language.name}
          </Badge>
        ))}
        {canSeeRates && profile.rates.length > 0 && (
          <Badge variant="secondary" className="ml-auto">
            From {profile.rates[0].price} {profile.rates[0].currency}
          </Badge>
        )}
      </div>
    </div>
  );
};

export default ProfileCardContent;
